import React, { useEffect, useState } from "react";
import { Card, Collapse, Form, InputNumber, TimePicker } from "antd";
import dayjs from "dayjs";

import { getFromLocalStorage, writeToLocalState } from "utils/localStorage";
import { SettingsSectionForm } from "./components/SettingsSectionForm";
import { useAppDispatch } from "store";
import {
  loadSettingsAction,
  updateSettingsAction,
} from "store/settings/settings.actions";
import { ISettingsData } from "types/settings.types";

const LOCAL_STORAGE_KEY = "settingsOpenPanels";

const disabledTime = () => {
  const disabledHours = () => {
    let hours: number[] = [];
    return hours;
  };
  const disabledMinutes = () => {
    let minutes: number[] = [];
    return minutes;
  };
  const disabledSeconds = (hour: number, minute: number) => {
    let seconds: number[] = [];
    if (!hour && !minute) {
      seconds.push(0);
    }
    return seconds;
  };
  return {
    disabledHours,
    disabledMinutes,
    disabledSeconds,
  };
};

const disabledCardTime = () => {
  const disabledHours = () => {
    return Array.from({ length: 23 }, (_, i) => i + 1);
  };
  const disabledMinutes = () => {
    let minutes: number[] = [];
    return minutes;
  };
  const disabledSeconds = (hour: number, minute: number) => {
    let seconds: number[] = [];
    if (!hour && !minute) {
      seconds.push(0);
    }
    return seconds;
  };
  return {
    disabledHours,
    disabledMinutes,
    disabledSeconds,
  };
};

const Settings = () => {
  const dispatch = useAppDispatch();
  const [settings, setSettings] = useState<ISettingsData>({});

  useEffect(() => {
    const load = async () => {
      const data = await dispatch(loadSettingsAction());
      setSettings(data);
    };
    load();
  }, []);

  const handleUpdateSettings = async (values: any) => {
    const data = Object.keys(values).reduce((acc, settingKey) => {
      if (
        ["card_timer_seconds", "push_timer_before_visit_seconds"].includes(
          settingKey
        )
      ) {
        acc[settingKey] =
          values[settingKey].startOf("second").diff(dayjs().startOf("day")) /
          1000;
      } else {
        acc[settingKey] = values[settingKey];
      }
      return acc;
    }, {} as Partial<ISettingsData>);
    const newSettings = await dispatch(
      updateSettingsAction({
        data: { ...settings, ...data } as ISettingsData,
      })
    );
    setSettings(newSettings);
  };
  const handleChangeActiveCollapsePanel = (openedPanels: string | string[]) => {
    writeToLocalState(LOCAL_STORAGE_KEY, openedPanels);
  };

  return (
    <Card title="Настройки">
      <Collapse
        defaultActiveKey={getFromLocalStorage(LOCAL_STORAGE_KEY)}
        onChange={handleChangeActiveCollapsePanel}
      >
        {/* <Collapse.Panel header="Дисконтная карта" key="1" forceRender={true}>
          <SettingsSectionForm<any>
            onSubmit={handleUpdateSettings}
            initialValues={{
              card_max_attempts: settings["card_max_attempts"],
              card_timer_seconds: dayjs()
                .startOf("day")
                .second(settings["card_timer_seconds"]),
            }}
          >
            <Form.Item
              name="card_max_attempts"
              label="Количество попыток ввода номера дисконтной карты"
              required
            >
              <InputNumber min={1} />
            </Form.Item>
            <Form.Item
              name="card_timer_seconds"
              label="Таймер повторного ввода номера дисконтной карты"
              required
            >
              <TimePicker
                inputReadOnly
                allowClear={false}
                format="H ч. m мин. s сек."
                showNow={false}
                disabledTime={disabledCardTime}
              />
            </Form.Item>
          </SettingsSectionForm>
        </Collapse.Panel> */}
        <Collapse.Panel
          header="Настройка времени до отправки PUSH-уведомлений"
          key="2"
          forceRender={true}
        >
          <SettingsSectionForm<any>
            initialValues={{
              push_timer_before_visit_seconds: dayjs()
                .startOf("day")
                .second(settings?.["push_timer_before_visit_seconds"]),
            }}
            onSubmit={handleUpdateSettings}
          >
            <Form.Item
              name="push_timer_before_visit_seconds"
              label="Запись на анализы или прием"
              required
            >
              <TimePicker
                inputReadOnly
                allowClear={false}
                format="H ч. m мин. s сек."
                showNow={false}
                disabledTime={disabledTime}
              />
            </Form.Item>
          </SettingsSectionForm>
        </Collapse.Panel>
      </Collapse>
    </Card>
  );
};

export default Settings;
